/**
 * Generated by orval v7.19.0 🍺
 * Do not edit manually.
 * GTO Wizard API v4
 * API documentation for GTO Wizard frontend API
 * OpenAPI spec version: 4
 */

export type AffiliatePartnerRole = (typeof AffiliatePartnerRole)[keyof typeof AffiliatePartnerRole]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AffiliatePartnerRole = {
  PARTNER: 'PARTNER',
  MANAGER: 'MANAGER',
  ACCOUNTANT: 'ACCOUNTANT',
  ADMIN: 'ADMIN',
} as const
